import { redirect, type LoaderFunctionArgs } from "react-router";

import { login } from "../shopify.server";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }
  return null;
};

export default function Index() {
  return (
    <div style={{ padding: 32, fontFamily: "sans-serif" }}>
      <h1>Restocks & Pre-orders</h1>
      <p>
        This is a private Shopify app for Runeforge Distribution. Install it
        from the Partner dashboard.
      </p>
    </div>
  );
}
